import { simpleSlider } from './components/simple-slider.js';
import { slider } from './components/slider.js';
import Menu from './components/menu.js';
import { text } from './components/text.js';
import InView from './components/in-view.js';




const headersliderElements = document.querySelectorAll( '[data-headerslider]' );
const sliderElements = document.querySelectorAll( '[data-slider]' );
const menuElement = document.querySelector('[data-menu]');
const textElements = document.querySelectorAll('[data-text]');
const inView = new InView( '[data-in-view]' );

if (headersliderElements && headersliderElements.length > 0) {
    headersliderElements.forEach(() => {
        simpleSlider();
    });
}

if (sliderElements && sliderElements.length > 0) {
    sliderElements.forEach(() => {
        slider();
    });
}

if ( menuElement ) {
    const menu = new Menu (menuElement);
}

if ( textElements && textElements.length > 0 ) {
    // textElements.forEach((textelement) => {
        text.init( textElements ) ;
        // const text = new Text (textelement);
    // )
}
